module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_Data-Set-15.a3a89407.png";